
import axios from 'axios';
import config from '../../config';
import { Error, API } from './base';


class AccountUser {
    constructor(obj){
        Object.assign(this, obj)
    }
}


class AccountUserAPI extends API {

    constructor(token, accountId) {
        super(token);
        this.accountId = accountId;
    }

    url() {
        return config.get("re.url") + "accounts/"+this.accountId+"/usersaccount";
    }

    urlBase() {
        return config.get("re.url") + "usersaccount";
    }

    urlGlobal() {
        return config.get("re.urlGlobal") + "management/clients/ecu/users/account";
    }

    getSessionUsersAccounts() {
        return new Promise((resolve, reject) => {
            axios.get(
              this.urlGlobal(),
              this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    const users = [];
                    response.data.users.forEach(u => {
                        users.push(new AccountUser(u));
                    });
                    resolve(users);
                } else {
                    const err = new Error(response.status, "Failed to fetch user", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    getAllUsers(filters) {
        return new Promise((resolve, reject) => {
            axios.get(encodeURI(this.urlBase()+(filters != null ? filters: '')), this._getHeaders()).then(response => {
                if (response.status === 200) {
                    const dbs = [];
                    response.data.usersaccount.forEach(u => {
                        dbs.push(new AccountUser(u));
                    });
                    resolve(dbs);
                } else {
                    const err = new Error(response.status, "Failed to fetch account's users", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    getAll() {
        return new Promise((resolve, reject) => {
            axios.get(this.url(), this._getHeaders()).then(response => {
                if (response.status === 200) {
                    const dbs = [];
                    response.data.usersaccount.forEach(u => {
                        dbs.push(new AccountUser(u));
                    });
                    resolve(dbs);
                } else {
                    const err = new Error(response.status, "Failed to fetch account's users", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    get(id) {
        return new Promise((resolve, reject) => {
            axios.get(this.url(), this._getHeaders()).then(response => {
                if (response.status === 200) {
                    resolve(new AccountUser(response.data.usersaccount));
                } else {
                    const err = new Error(response.status, "Failed to fetch account's user", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    update(u) {
        return new Promise((resolve, reject) => {
            axios.patch(this.url(), u, this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to update account's user", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete(this.url(), this._getHeaders()).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to delete account's user", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    create(u) {
        return new Promise((resolve, reject) => {
            axios.post(this.url(), u, this._getHeaders(),
            ).then(response => {
                if (response.status === 201) {
                    resolve(new AccountUser(response.data.useraccount));
                } else {
                    const err = new Error(response.status, "Failed to create account's user", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }
}

export {
    AccountUserAPI, AccountUser
};